import { useInView } from './hooks';

export default function SectionHead({ index, label, title, lede }) {
  const [ref, inView] = useInView();
  const words = title.split(' ');

  return (
    <div ref={ref} className={`section__head reveal${inView ? ' is-in' : ''}`}>
      <p className="kicker">
        <span>{index}</span>
        {label}
      </p>
      <h2 className="words">
        {words.map((word, wordIndex) => (
          <span key={`${word}-${wordIndex}`} style={{ transitionDelay: `${90 + wordIndex * 36}ms` }}>
            {word}
            {wordIndex < words.length - 1 ? '\u00A0' : ''}
          </span>
        ))}
      </h2>
      {lede ? <p className="lede">{lede}</p> : null}
    </div>
  );
}